<template>
    <comp-9-art-adherence :section="9" :page="53" :nextDisabled="nextDisabled" :next="nextScreen">
        <p>
            Great! All these reasons and more! Now, how do these reasons translate to taking your ART every day? Being able to answer that question is super
            important because ART is most effective when it’s taken every day.
        </p>
        <p>
            Thinking about the last 30 days, how often did you take your HIV medicines the way you were supposed to?
        </p>
        <v-radio-group v-model="artAdherenceSelection" column>
            <v-radio v-for="adherence in artAdherences" :key="adherence.id" :label="adherence.text" :value="adherence"></v-radio>
        </v-radio-group>
    </comp-9-art-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { find, forEach } from 'lodash';

export default {
    data: function() {
        return {
            artAdherenceSelection: null
        };
    },
    computed: {
        artAdherence() {
            let selectedArtAdherence = find(this.artAdherences, 'selected');

            if (selectedArtAdherence) {
                return selectedArtAdherence;
            } else return null;
        },
        artAdherences: sync('section9/artAdherence'),
        nextScreen() {
            if (this.artAdherenceSelection) {
                return `/page/9/${this.artAdherenceSelection.nextScreen}`;
            }

            return null;
        }
    },
    methods: {
        nextDisabled() {
            return !this.artAdherenceSelection;
        }
    },
    watch: {
        artAdherenceSelection(newArtAdherenceSelection) {
            forEach(this.artAdherences, o => {
                if (o.id === newArtAdherenceSelection.id) {
                    o.selected = true;
                } else {
                    o.selected = false;
                }
            });
        }
    },
    mounted() {
        this.artAdherenceSelection = this.artAdherence;
    }
};
</script>
